import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Row, Col, Label } from "reactstrap";
import { getHour } from "../../Constants/Services";
import { IHour } from "../../Constants/Interfaces";
import { HOUR_CLASS, validateTokenStorage,HOUR_BODY_PRINT} from "./../../Constants/Util";
import StoreContext from "./../../../Store/Context";
import { printComponent } from "react-print-tool";


interface IHourState {
  typePerson:string;
  dataHour: IHour[];
}

class Schedule extends Component<RouteComponentProps<{}>, IHourState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      typePerson: "student",
      dataHour: [],
    };

    this.fetchHour = this.fetchHour.bind(this);
    this.onClickPrint = this.onClickPrint.bind(this);
  }

  async fetchHour() {
    var response;
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      response = await getHour(this.context.per_std);
    } else {
      response = await getHour(this.context.per_id);
    }

    this.setState({
      dataHour: response,
    });
  }

  componentDidMount() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.fetchHour();
  }

  onClickPrint = () => {
    const props = this.state;
    printComponent(
      <HOUR_BODY_PRINT
        typePerson={props.typePerson}
        dataHour={props.dataHour}
      />
    );
  };
  
  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Row>
          <Col sm={12} id="schedule">
            {props.dataHour.length > 0 ? (
              <React.Fragment>
                <HOUR_CLASS dataHour={props.dataHour} type={props.typePerson}  onPrint={this.onClickPrint}/>
              </React.Fragment>
            ) : (
              <Row>
                <Col xs={12} className="text-center">
                  <h4 className="font-weight-bold">Horario</h4>
                </Col>
                <Col xs={12} className="text-center">
                  <Label className="font-weight-bold result-none">Sin Resultados</Label>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
export default Schedule;
